import { Box, Skeleton } from "@mui/material";
import { SkeletonBar } from "pages/Dashboard/styles";

export const LoadingScreen = () => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection={"column"}
        sx={{ marginTop: "150px" }}
      >
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "15%" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "20%", bgcolor: "grey" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "25%" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "30%", bgcolor: "grey" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "33%" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "30%", bgcolor: "grey" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "25%" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "20%", bgcolor: "grey" } }}
        />
        <br />
        <Skeleton
          variant="rectangular"
          sx={{ ...SkeletonBar, ...{ width: "15%" } }}
        />
      </Box>
    </>
  );
};
